export default __webpack_public_path__ + "static/DLA_SHARE_1200x630-ba98348ed2863aa6f6ea9bc9b02b1135.jpg";